// extracted by mini-css-extract-plugin
module.exports =  {"root":"Icu9zgLrMn5scsqqDNVy","icon":"t4F5xRozqtFD3o8OFzfK"};